import { API_BASE_URL } from "../config/api";

const PUBLIC_NEWS_PREFIX = "/public/news";

function buildQuery(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

async function request(endpoint, options = {}) {
  if (!API_BASE_URL) {
    throw new Error("API base URL is not configured. Set REACT_APP_API_BASE_URL in .env");
  }

  const url = endpoint.startsWith("http") ? endpoint : `${API_BASE_URL}${endpoint}`;
  const response = await fetch(url, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw Object.assign(new Error(data.message || data.error || response.statusText), {
      status: response.status,
      data,
    });
  }

  return data;
}

export function getNews(page = 1, search = "") {
  return request(`${PUBLIC_NEWS_PREFIX}${buildQuery({ page, search })}`);
}

export function getLatestNews(search = "") {
  return request(`${PUBLIC_NEWS_PREFIX}/latest${buildQuery({ search })}`);
}

export function getTrendingNews(search = "") {
  return request(`${PUBLIC_NEWS_PREFIX}/trending${buildQuery({ search })}`);
}

export function getTags() {
  return request(`${PUBLIC_NEWS_PREFIX}/tags`);
}

export function getNewsByTag(tag, page = 1, search = "") {
  return request(
    `${PUBLIC_NEWS_PREFIX}/tags/${encodeURIComponent(tag)}${buildQuery({ page, search })}`
  );
}

export function getNewsById(id) {
  return request(`${PUBLIC_NEWS_PREFIX}/${id}`);
}
